import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { OptionMarket } from '@cds/betting-offer';
import { Optional } from '@frontend/sports/common/core/utils/extended-types';
import { HorseRaceSortingDirection, WinGameFixture } from '@frontend/sports/racing/feature/models';

import { DropdownOption, OptionType } from '../../../dropdown/models';
import { GreyhoundTrackingService } from '../../common/greyhound-tracking.service';
import { BaseRaceWinMarketService } from '../base/base-race-win-market.service';

interface AntepostMarketViewModel {
    fixture: WinGameFixture;
    isOptionBet: boolean;
    optionMarket: Optional<OptionMarket>;
}

@Component({
    selector: 'ms-antepost-market',
    templateUrl: 'antepost-market.html',
    standalone: false,
})
export class AntepostMarketComponent implements OnInit, OnChanges {
    private _fixture: WinGameFixture;
    activeOption: DropdownOption;
    dropDownItems: DropdownOption[];
    sortBy: HorseRaceSortingDirection = HorseRaceSortingDirection.Odds;

    @Input() showFixtureMarketTitle = false;
    @Input() skipSortingTracking = false;

    @Input()
    set fixture(fixture: WinGameFixture) {
        this._fixture = fixture;
    }

    get fixture(): WinGameFixture {
        return this._fixture!;
    }

    vm: AntepostMarketViewModel | undefined;

    constructor(
        private baseRaceWinMarketService: BaseRaceWinMarketService,
        private greyhoundTrackingService: GreyhoundTrackingService,
    ) {
        this.dropDownItems = [
            { id: HorseRaceSortingDirection.Odds, name: 'Odds', type: OptionType.Regular },
            { id: HorseRaceSortingDirection.AtoZ, name: 'AtoZ', type: OptionType.Regular },
        ];
    }

    ngOnInit() {
        this.updateViewModel(this._fixture);
        this.activeOption = this.baseRaceWinMarketService.getActiveSortOption(HorseRaceSortingDirection.Odds);
        this.orderBy(HorseRaceSortingDirection.Odds);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.fixture?.currentValue) {
            this.updateViewModel(changes.fixture.currentValue);
        }
    }

    private updateViewModel(fixture: WinGameFixture): void {
        const isOptionBet = fixture.isOptionBet;

        this.vm = {
            fixture,
            isOptionBet,
            optionMarket: isOptionBet ? fixture.optionMarkets[0] : undefined,
        };
    }

    orderBy(sortBy: HorseRaceSortingDirection): void {
        this.activeOption.id = sortBy;
        this.sortBy = sortBy;

        this.trackSorting(sortBy);
    }

    trackDropdownToggle(): void {
        this.trackSorting(undefined);
    }

    private trackSorting(sortBy?: HorseRaceSortingDirection): void {
        if (this.skipSortingTracking) {
            return;
        }

        this.greyhoundTrackingService.trackSorting(this.fixture, sortBy, 'win each way');
    }
}
